export default __webpack_public_path__ + "static/media/Play-Clips.aaf1c04b.svg";